import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { IconSort } from '../../../../../components/icons/IconSort';
import { IconFiltersMobile } from '../../../../../components/icons/IconFiltersMobile';
import { getVerbalHotelReviews } from '../../../../utils/format';
import { SortByType } from '../../../../models/hotel-reviews';
import S from '../../../../stores';

export interface SortReviewProps {
    reviewAmount: number;
    isMobile: boolean;
}

interface SortReviewState {
    dateSortAsk: boolean;
    ratingSortAsk: boolean;
}

interface StyledSortReviewProps extends JSSClassesProps<ComponentJSSClasses>, SortReviewProps {}

@observer
export class SortReview extends React.Component<StyledSortReviewProps, SortReviewState> {
    constructor(props: StyledSortReviewProps) {
        super(props);
        this.state = {
            dateSortAsk: false,
            ratingSortAsk: true
        };
    }

    handleSwitchSortBy = (sort: SortByType ): any => {
        S.hotelReviews.setReviewSortBy(sort);
    }

    handleSwitchRatingSort = (): void => {
        const newSortType = this.state.ratingSortAsk ? SortByType.Positive : SortByType.Negative;
        this.handleSwitchSortBy(newSortType);
        this.setState({ ...this.state, ratingSortAsk: !this.state.ratingSortAsk});
    }

    handleSwitchDateSort = (): void => {
        const newSortType = this.state.dateSortAsk ? SortByType.Newest : SortByType.Oldest;
        this.handleSwitchSortBy(newSortType);
        this.setState({ ...this.state, dateSortAsk: !this.state.dateSortAsk});
    }

    sortByRatingIsActive = (): boolean =>  (
            S.hotelReviews.sortBy === SortByType.Positive ||
            S.hotelReviews.sortBy === SortByType.Negative
    )

    handleOpenMobileFilter = () => {
        S.hotelReviews.setMobileFiltersOpen(true);
    }

    render() {
        const { classes, reviewAmount, isMobile } = this.props;

        return (
        <div className={classes.container}>
            <div className={classes.reviewAmountFilterBtnWrap}>
             <p className={classes.reviewAmount}>
                    <strong>{reviewAmount}</strong> {getVerbalHotelReviews(reviewAmount)}
                </p>
                   {isMobile && (
                    <button
                        className={classes.mobileFiltersButton}
                        onClick={this.handleOpenMobileFilter}
                    >
                        <IconFiltersMobile />
                    </button>
                )}
            </div>
            <div className={classes.sortButtons}>
                <button
                    className={`${classes.sortButton} ${this.sortByRatingIsActive() ? '' : classes.sortButtonActive}`}
                    onClick={this.handleSwitchDateSort}
                >
                    <span
                        className={
                        this.state.dateSortAsk
                            ? ''
                            : classes.descIcon }
                    >
                        <IconSort />
                    </span>
                    дата добавления
                </button>
                <button
                    className={`${classes.sortButton} ${this.sortByRatingIsActive() ? classes.sortButtonActive : ''}`}
                    onClick={this.handleSwitchRatingSort}
                >
                    <span
                        className={
                        this.state.ratingSortAsk
                        ? ''
                        : classes.descIcon }
                    >
                        <IconSort />
                    </span>
                    оценка
                </button>
            </div>
        </div>
    );
    }
}
